import type { SwidgeGetOutput } from '@infinex/actions';

import { ActivityStatus } from '../types/index';

// TODO: @sneedinfinex map to backend status
export const mapSwidgeStatusToActivityStatus = (
  status: SwidgeGetOutput['status']
): ActivityStatus => {
  switch (status) {
    case 'requested':
    case 'deposited':
    case 'available':
    case 'open':
      return ActivityStatus.CREATED;
    case 'filled':
      return ActivityStatus.SUCCESS;
    case 'refunded':
    case 'canceled':
    case 'failed':
      return ActivityStatus.ERROR;
    default:
      return ActivityStatus.CREATED;
  }
};
export const mapGenericStatus = (
  status:
    | 'initiated'
    | 'created'
    | 'started'
    | 'claimed'
    | 'ready'
    | 'pending'
    | 'success'
    | 'error'
    | 'requested'
    | 'refunded'
    | 'unclaimed'
    | 'failed'
    | 'draft'
    | 'review'
): ActivityStatus => {
  if (status === 'draft') {
    throw new Error('Never');
  }
  switch (status) {
    case 'requested':
    case 'ready':
    case 'created':
    case 'unclaimed':
      return ActivityStatus.CREATED;
    case 'initiated':
    case 'pending':
    case 'started':
      return ActivityStatus.PROCESSING;
    case 'success':
    case 'claimed':
      return ActivityStatus.SUCCESS;
    case 'error':
    case 'failed':
    case 'refunded':
      return ActivityStatus.ERROR;
    case 'review':
      return ActivityStatus.REVIEW;
    default:
      return ActivityStatus.CREATED;
  }
};
export const isLoadingStatus = (status: ActivityStatus): boolean => {
  return (
    status === ActivityStatus.CREATED || status === ActivityStatus.PROCESSING
  );
};
export const isErrorStatus = (status: ActivityStatus): boolean => {
  return status === ActivityStatus.ERROR;
};

export const isReviewStatus = (status: ActivityStatus): boolean => {
  return status === ActivityStatus.REVIEW;
};
